import type { DiscountEffectType } from "types"

export const calcDiscountPrice = (
  effects: DiscountEffectType[],
  price = 0
): number => {
  return effects.reduce((acc, effect) => {
    switch (effect?.valueType) {
      case "percentage":
        return acc - (acc * (effect.value ?? 0)) / 100

      case "monthsFree":
        return (effect?.value ?? 0) > 0 ? 0 : acc

      case "amount": {
        const discountedPrice = acc - (effect?.value ?? 0)
        return discountedPrice >= 0 ? discountedPrice : 0
      }

      default:
        return acc
    }
  }, price)
}
